import React, { useState } from 'react';
import { Layout } from '../components/layout/Layout';
import { AdminNav } from '../components/admin/AdminNav';
import { AdminLoginCard } from '../components/admin/AdminLoginCard';
import { useAdminAuth } from '../hooks/useAdminAuth';
import { signOutUser } from '../utils/adminAuth';

export default function Admin() {
  const { user, authUser, loading, isAuthenticated, isAdmin } = useAdminAuth();
  const [error, setError] = useState('');

  const handleSignOut = async () => {
    setError('');
    await signOutUser();
  };

  return (
    <Layout>
      <div className="section-padding">
        <div className="container-zinga">
          <h1 className="font-display text-3xl md:text-4xl font-bold mb-6">Admin</h1>
          {loading ? (
            <div className="rounded-3xl border border-[#0F3D2C] p-8 md:p-10 max-w-2xl bg-card/60">
              <p className="text-sm text-muted-foreground">Betöltés...</p>
            </div>
          ) : isAuthenticated && !isAdmin ? (
            <div className="rounded-3xl border border-destructive/40 p-8 md:p-10 bg-card/60 max-w-3xl">
              <p className="text-sm text-destructive font-medium">
                A fiók be van jelentkezve, de nincs admin jogosultsága.
              </p>
              <p className="mt-2 text-xs text-muted-foreground break-words">
                UID: {authUser?.uid || 'ismeretlen'}
              </p>
              <p className="mt-1 text-xs text-muted-foreground">
                Adj hozzá dokumentumot az <code>admins/{authUser?.uid || '{uid}'}</code> vagy
                <code> admin/{authUser?.uid || '{uid}'}</code> útvonalon, vagy vedd fel a UID-t a
                legacy <code>admins/Main</code> docba.
              </p>
              <button onClick={handleSignOut} className="btn-secondary text-sm mt-4">
                Kijelentkezés
              </button>
            </div>
          ) : user ? (
            <div className="rounded-3xl border border-[#0F3D2C] p-8 md:p-10 bg-card/60">
              <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
                <div>
                  <p className="text-xs text-muted-foreground">Bejelentkezve</p>
                  <p className="text-sm md:text-base font-medium">{user.displayName || user.email}</p>
                </div>
                <button onClick={handleSignOut} className="btn-secondary text-sm">
                  Kijelentkezés
                </button>
              </div>
              <p className="text-sm text-muted-foreground mb-4">
                Válassz admin szekciót:
              </p>
              <AdminNav />
              {error && <p className="mt-4 text-sm text-destructive">{error}</p>}
            </div>
          ) : (
            <AdminLoginCard />
          )}
        </div>
      </div>
    </Layout>
  );
}
